// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"13d05344","879":"1973e0bf","977":"17c6ba7d"}[chunkId] + ".chunk.js";
};